import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import { Text, Checkbox, Button } from '@beef/ui-kit';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const AcceptInvitation = ({
  title,
  description,
  label,
  acceptButtonText,
  rejectButtonText,
  termUseText,
  isChecked,
  handleCheckboxChange,
  acceptClick,
  rejectClick,
  isLoading,
  termUserButtonText,
  termUserButtonLink,
}) => (
  <form>
    <div className={cn('form__title')}>
      <Text tagType="h3" size="size2-m">
        {title}
      </Text>
    </div>
    <div className={cn('form__description')}>
      <Text size="size5-r-s">
        {description}
      </Text>
    </div>
    <div className={cn('form__checkbox')}>
      <Checkbox
        label={label}
        name="permission"
        checked={isChecked}
        onChange={handleCheckboxChange}
        size="small"
      />
    </div>
    <div className={cn('form__group-btn')}>
      <Button
        variant="secondary"
        size="m"
        onClick={acceptClick}
        disabled={isLoading}
        isLoading={isLoading}
      >
        {acceptButtonText}
      </Button>
      <Button
        variant="tertiary"
        size="m"
        onClick={rejectClick}
        disabled={isLoading}
        isLoading={isLoading}
      >
        {rejectButtonText}
      </Button>
    </div>
    <div className={cn('form__terms')}>
      <Text size="size5-m">
        {termUseText}
        &nbsp;
        <a href={termUserButtonLink}>
          {termUserButtonText}
        </a>
      </Text>
    </div>
  </form>
);

AcceptInvitation.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  label: PropTypes.string,
  acceptButtonText: PropTypes.string,
  rejectButtonText: PropTypes.string,
  termUseText: PropTypes.string,
  isChecked: PropTypes.bool,
  handleCheckboxChange: PropTypes.func,
  acceptClick: PropTypes.func,
  rejectClick: PropTypes.func,
  isLoading: PropTypes.bool,
  termUserButtonText: PropTypes.string,
  termUserButtonLink: PropTypes.string,
};

export { AcceptInvitation };
